import { CORRELATION_CARD, EVOLUTIVE_CARD, EVOLUTIVE_CROSS_CARD, MULTIPLE_CARD, SIMPLECROSS_CARD, SIMPLE_CARD } from "src/sections/GroupCards/cardTypes"

const strategies = {
  [SIMPLE_CARD]: 'chartConfigData',
  [MULTIPLE_CARD]: 'multiCrossChartConfigData',
  [SIMPLECROSS_CARD]: 'simpleCrossChartConfigData',
  [EVOLUTIVE_CARD]: 'evolutiveChartConfigData',
  [EVOLUTIVE_CROSS_CARD]: 'evolutiveCrossChartConfigData',
  [CORRELATION_CARD]: 'correlationChartConfigData',
};

/**
 * 
 * @param {string} cardType 
 * @returns {string} Key correspondente do estado de configuração de um gráfico no redux
 */
export default function resolveChartConfigurationState(cardType = SIMPLE_CARD) {
  return strategies[cardType];
}